import React from "react";
import { SectionProps } from "./types";

const Section: React.FC<SectionProps> = ({
	additionalClasses,
	children,
	padding = "py-16",
}) => {
	let className = "section";

	return (
		<section className={`${className} ${padding} ${additionalClasses}`}>
			{children}
		</section>
	);
};

export default Section;
